import { Icon } from "assets/Icon";
import { FormattedInput } from "components/FormInputs/FormattedInput";
import { useField } from "formik";
import React, { useState } from "react";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";

const TableText = ({ name, rowIndex, colIndex, value, required, disabled }) => {
	const [, meta] = useField(`${name}[${rowIndex}]`);

	let displayValue = value;
	const isRequired = required === 1 || required === true;

	// this is the answer column
	if (colIndex === 1) {
		displayValue = value && value.length > 0 ? value : "Click to Answer here";
	}

	const isValidValue = typeof meta?.value === "string" && meta.value.length > 0;

	const renderTextValue =
		colIndex === 1 && isValidValue
			? meta?.value
			: `<span class="italic text-gray-400">${displayValue}</span>`;

	return (
		<div className="relative">
			<div
				className={`${colIndex === 0 && "font-bold"} rfx-response-table ${disabled ? "cursor-default" : "cursor-text"}`}
				dangerouslySetInnerHTML={{ __html: renderTextValue }}
			/>
			{isRequired && meta.error && colIndex === 1 && (
				<p className="mt-1 text-sm text-red-500">{meta.error}</p>
			)}
		</div>
	);
};

export const TableQuestionnaire = ({
	tableQuestions,
	question,
	required,
	...props
}) => {
	const headers = tableQuestions.map((row) => row.header);
	const values = tableQuestions[0]?.values?.map((_, index) =>
		tableQuestions.map((row) => (row?.values ? row.values[index] : ""))
	);
	const [editIndex, setEditIndex] = useState({});

	return (
		<div>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
			/>
			<table className="mb-2 mt-4 w-full table-auto rounded-xl border-b border-solid border-[#EAECF0] bg-white">
				<thead>
					<tr>
						{headers?.map((header, index) => (
							<th
								key={index}
								className="w-1/5 bg-[#F9FAFB] p-2 text-left font-roboto font-medium text-tertiary-600"
							>
								<h2 className="font-bold">{header}</h2>
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{values?.map((row, rowIndex) => (
						<tr
							key={rowIndex}
							className="border-b border-[#EAECF0]"
						>
							{row.map((value, colIndex) => (
								<td className="border border-[#EAECF0] px-3 text-left align-top font-roboto font-normal text-primary-500">
									{editIndex?.rowIndex === rowIndex && colIndex === 1 ? (
										<div className="flex w-full items-start gap-2">
											{props?.name && (
												<>
													<FormattedInput
														name={
															`${props?.name}[${rowIndex}]` || "questionnaire"
														}
														placeholder="value"
														onClick={() => setEditIndex({ colIndex, rowIndex })}
														className="w-full"
														disabled={props.disabled}
													/>
													<button onClick={() => setEditIndex({})}>
														<Icon icon="check" />
													</button>
												</>
											)}
										</div>
									) : (
										<p
											className="py-2"
											onClick={() =>
												colIndex === 1 &&
												!props?.disabled &&
												setEditIndex({ colIndex, rowIndex })
											}
										>
											{
												<TableText
													name={props?.name}
													rowIndex={rowIndex}
													colIndex={colIndex}
													value={value}
													required={required}
													disabled={props.disabled}
												/>
											}
											{/*  */}
										</p>
									)}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
